<template>
  <grid-item
      legend="Habilitação em Leilões e Lotes"
      icon="check" icon-type="fa"
      class=""
      ch-legend="ARREMATANTES QUE SOLICITARAM HABILITAÇÃO E PRECISAM DE ANÁLISE"
      :link="() => $router.push({name: 'arrematantes.habilitacao'})"
  >
    <template>
      <monitor-aprovacao class="dash-monitor-wrapper"/>
    </template>
    <template v-slot:card-footer>
    </template>
  </grid-item>
</template>

<script>
import GridItem from '@/components/dashboard/includes/GridItem'
// import CardItemLink from '@/reuse/card/CardItemLink'
import MonitorAprovacao from "components/arrematante/components/MonitorHabilitacao"

export default {
  name: "DashAprovacaoCadastroWrapper",
  mixins: [],
  components: {GridItem, MonitorAprovacao},
  computed: {},
  methods: {}
}
</script>

<style lang="stylus">
.dash-monitor-wrapper {
  position relative
}
</style>
